export const matchId = (valueToMatch: number) => (item: { id?: number }) => {
  return valueToMatch === item.id;
};

export const hasDuplicates = (arr: Array<number | string>): boolean =>
  new Set(arr).size !== arr.length;

export const areArraysEqual = (a: Array<any>, b: Array<any>): boolean =>
  a.every((num, i) => num === b[i]);

export const isEmptyArray = (valueToCheck: any): boolean => {
  return Array.isArray(valueToCheck) && valueToCheck.length === 0;
};

export const getExactCopyWithoutReference = <T>(x: Array<T>): Array<T> =>
  JSON.parse(JSON.stringify(x));

export const allExcept = (exclude: string[]) => (item: string) => !exclude.includes(item);
